
export default {
  name: 'btn',
  props: {
    size: {
      type: String,
      required: false,
    },
    list: {
      type: Boolean,
      required: false,
    },
    bg: {
      type: String,
      required: false,
    },
    link: {
      type: [String, Object],
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
  },
}
